import * as ui from "../../app/core/ui";

var view = () => new ui.Container({
    classes: "mar-t-14",
    id: "CallItemsTabsContainer",
    components: [
        new ui.TabStrip({
            id: "CallItemsTabs",
            tabs: [
                {
                    label: "QuickView",
                    id: "QuickView"
                },
                {
                    label: "JSON",
                    id: "JSON"
                }
            ],
            components: [
                new ui.TabContents({
                    components: [
                        new ui.Container({
                            classes: "container no-pad col-xs-12",
                            id: "QuickViewContainer",
                            components: [
                                new ui.Container({
                                    id: "ErrorCounters",
                                    classes: "ctrl-tilde-error-count-container",
                                    components: [
                                        new ui.Container({
                                            classes: "col-xs-6",
                                            components: [
                                                new ui.Container({
                                                    classes: "ctrl-tilde-error-circle-wrapper",
                                                    components: [
                                                        new ui.Container({
                                                            id: "RequestResponseErrorCount",
                                                            classes: "badge ctrl-tilde-error-circle"
                                                        }),
                                                        new ui.Label({
                                                            classes: "ctrl-tilde-error-label",
                                                            bindValue: "AjaxErrors"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        new ui.Container({
                                            classes: "col-xs-6",
                                            components: [
                                                new ui.Container({
                                                    classes: "ctrl-tilde-error-circle-wrapper",
                                                    components: [
                                                        new ui.Container({
                                                            id: "ConsoleErrorCount",
                                                            classes: "badge ctrl-tilde-error-circle"
                                                        }),
                                                        new ui.Label({
                                                            classes: "ctrl-tilde-error-label",
                                                            bindValue: "ConsoleErrors"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                new ui.HR(),
                                new ui.Grid({
                                    bsc: "special-column-widths",
                                    id: "ErrorGrid"
                                })
                            ]
                        })
                    ]
                }),
                new ui.TabContents({
                    components: [
                        new ui.TextArea({
                            id: "FullLog",
                            classes: "col-xs-12"
                        })
                    ]
                })
            ]
        })
    ]
});

export default view;
